import React, { useState } from 'react';
import StatsCard from './StatsCard';
import './Hero.css';
import { submitForm } from '../utils/formSubmit';
import Swal from 'sweetalert2';

const Hero = () => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    email: '',
    name: '',
    phone: '',
    country: 'Canada',
    course: 'Quran Reading'
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleNext = (e) => {
    e.preventDefault();
    if (step === 1 && !formData.email) return;
    if (step === 2 && !formData.name) return;
    if (step === 3 && !formData.phone) return;
    setStep((prev) => prev + 1);
  };

  const handlePrevious = (e) => {
    e.preventDefault();
    setStep((prev) => prev - 1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await submitForm('Hero Multi-Step Subscription', formData);
      Swal.fire({
        title: 'Thank you!',
        text: `Your trial request has been submitted successfully. We will contact you soon.`,
        icon: 'success',
        confirmButtonColor: '#5c9456'
      });
      setStep(1);
      setFormData({
        email: '',
        name: '',
        phone: '',
        country: 'Canada',
        course: 'Quran Reading'
      });
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: 'Failed to submit form. Please try again.',
        icon: 'error',
        confirmButtonColor: '#5c9456'
      });
    }
  };

  return (
    <section
      className="hero"
      style={{
        backgroundImage: `linear-gradient(rgba(92, 148, 86, 0.88), rgba(92, 148, 86, 0.88)), url('${process.env.PUBLIC_URL}/assets/images/Hero-5.jpg')`
      }}
    >
      <div className="hero__container">
        {/* Left Column: Content and Form */}
        <div className="hero__content">
          <div className="hero__badge">
            <svg aria-hidden="true" className="hero__badge-icon" viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
              <path d="M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z" />
            </svg>
            <span>100% Satisfaction Guarantee</span>
          </div>

          <h1 className="hero__title">
            Online <span className="hero__title--highlight">Quran Classes for Kids & Adults in the USA</span> - Learn Quran Online Live with Certified Tutors
          </h1>

          <p className="hero__description">
            If you've been searching for online Quran classes for your child, or thinking about picking the Quran back up yourself, you already know the hard part isn't finding an option; it's finding one you can trust. Al Quran Lesson provides live Quran classes across the United States with certified, native Arabic-speaking tutors for one-on-one Quran classes, taught around your family's actual schedule. We've been doing this since 2013, and over 5,000 students have learned with us. Start with a 3-day free trial, no card needed.
          </p>

          <form className="hero__form" onSubmit={step === 5 ? handleSubmit : handleNext}>
            {step === 1 && (
              <input
                type="email"
                name="email"
                className="hero__input"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            )}
            {step === 2 && (
              <input
                type="text"
                name="name"
                className="hero__input"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            )}
            {step === 3 && (
              <input
                type="tel"
                name="phone"
                className="hero__input"
                placeholder="Phone No"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            )}
            {step === 4 && (
              <select
                name="country"
                className="hero__select"
                value={formData.country}
                onChange={handleChange}
                required
              >
                <option value="USA">USA</option>
                <option value="Canada">Canada</option>
                <option value="UK">UK</option>
                <option value="Australia">Australia</option>
                <option value="Other">Other</option>
              </select>
            )}
            {step === 5 && (
              <select
                name="course"
                className="hero__select"
                value={formData.course}
                onChange={handleChange}
                required
              >
                <option value="Noorani Qaida">Noorani Qaida</option>
                <option value="Quran with Tajweed">Quran with Tajweed</option>
                <option value="Quran Reading">Quran Reading</option>
                <option value="Quran Memorization">Quran Memorization</option>
                <option value="Quran Translation">Quran Translation</option>
                <option value="Arabic Grammar">Arabic Grammar</option>
              </select>
            )}

            <div className="hero__form-buttons">
              {step > 1 && (
                <button
                  type="button"
                  className="hero__prev-btn"
                  onClick={handlePrevious}
                >
                  Previous
                </button>
              )}
              {step < 5 ? (
                <button type="submit" className="hero__submit-btn">
                  Next
                </button>
              ) : (
                <button type="submit" className="hero__submit-btn">
                  Send
                </button>
              )}
            </div>
          </form>
        </div>

        {/* Right Column: 2x2 Image Grid */}
        <div className="hero__grid">
          <div className="hero__grid-item hero__grid-item--top-left">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/Box-4-1.webp`}
              alt="online Quran Classes Live one-on-one"
              className="hero__grid-img"
            />
          </div>
          <div className="hero__grid-item hero__grid-item--top-right">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/Box-2-1-scaled-1.webp`}
              alt="nline Quran Classes Live one-on-one"
              className="hero__grid-img"
            />
          </div>
          <div className="hero__grid-item hero__grid-item--bottom-left">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/Box-5-1.webp`}
              alt="nline Quran Classes Live one-on-one"
              className="hero__grid-img"
            />
          </div>
          <div className="hero__grid-item hero__grid-item--bottom-right">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/Box-3.webp`}
              alt="nline Quran Classes Live one-on-one"
              className="hero__grid-img"
            />
          </div>
        </div>
      </div>
      <StatsCard />
    </section>
  );
};

export default Hero;

